import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Factory, HStack, Icon, Modal, Text } from 'native-base';
import { AntDesign } from '@expo/vector-icons';

import {
  useAddCouponResponsiveOverlayError
} from '@hooks/useAddCouponResponsiveOverlayError';

const TouchableOpacityFactory = Factory(TouchableOpacity);

export function Web() {
  const { isOpen, onClose } = useAddCouponResponsiveOverlayError();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Content maxWidth="504px" px={6} pb={6}>
        <Modal.CloseButton _icon={{
          size: 4,
          color: 'primary.600'
        }} />

        <Modal.Header pl={0}>
          <HStack alignItems='center'>
            <Icon
              as={AntDesign}
              name='warning'
              color='red.500'
              _dark={{
                color: 'red.400'
              }}
              size={8}
              mr={4}
            />

            <Text
              color='red.500'
              fontSize='lg'
              _dark={{
                color: 'red.400'
              }}
              fontFamily='subheading'>
              Remova os clientes para adicionar cupons
            </Text>
          </HStack>
        </Modal.Header>

        <Modal.Body px={0} pb={0} mb={10}>
          <Text fontSize='md' color='muted.800' _dark={{
            color: 'muted.500'
          }}>
            Não é possível adicionar cupons a um pedido compartilhado{"\n"}
            com vários clientes.
          </Text>
        </Modal.Body>

        <TouchableOpacityFactory
          testID='add-coupon-error-web_ok-button'
          bg='primary.600'
          h={12}
          rounded='sm'
          p={4}
          alignItems='center'
          justifyContent='center'
          _dark={{
            opacity: 0.8,
          }}
          onPress={onClose}
        >
          <Text fontSize='md' fontFamily='subheading' color='muted.100'>
            Ok
          </Text>
        </TouchableOpacityFactory>
      </Modal.Content>
    </Modal>
  );
}